










































import Vue from 'vue';
import OrgService from '@/api/org.service';
import DunningOnboardInitial from '@/components/Dunning/DunningOnboardInitial.vue';
import DunningWaitlistCard from '@/components/Dunning/DunningWaitlistCard.vue';
import { SYNC_DUNNING, SYNC_USER_RECORD } from '@/store/action-types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Dunning',
  components: {
    DunningOnboardInitial,
    DunningWaitlistCard,
  },
  data() {
    return {
      loading: true,
      creatingCampaignBlueprint: false,
      activating: false,
    };
  },
  async created() {
    await this.$store.dispatch(SYNC_DUNNING);
    this.loading = false;
  },
  computed: {
    ...mapGetters(['primaryCampaignBlueprintId', 'senderDomainReady', 'dunning', 'dunningAvailable', 'isReadyToActivate']),
    hasCampaign(): boolean {
      return !!this.primaryCampaignBlueprintId;
    },
  },
  methods: {
    async activateDunning() {
      this.activating = true;
      await OrgService.updateDunningSettings(this.$store.state.org._id, { enabled: true });
      await this.$store.dispatch(SYNC_USER_RECORD);
      this.activating = false;
      this.$router.push('/dunning/metrics');
    },
  },
});
